<template>
  <div class="full-height q-pa-md">
    <div class="col-6 label-crud-title q-px-lg q-pa-xs" v-if="name">
      {{ name }}
    </div>
    <q-card class="q-px-md">
      <q-card-section class="q-py-md q-px-lg full-height">
        <crud-form
          v-if="forms"
          ref="form"
          :form="forms[0]"
          :model="forms[0].dadosForm"
          :forms="forms[0].relacionamentos"
          class="row"
        >
          <crud-input
            class="col-5 q-px-sm"
            nmInput="segPerfilAcesso"
            @on-select-change="onSelectChangePerfilAcesso"
          />
          <crud-input
            class="col-5 q-px-sm"
            nmInput="segModulo"
            @on-select-change="onSelectChangeModulo"
          />
        </crud-form>
      </q-card-section>
      <q-card-section class="mtn-60">
        <div
          class="row full-width justify-end q-gutter-md"
        >
          <q-btn
            :disable="!customizeTree"
            flat
            round
            dense
            size="1.2em"
            icon="open_with"
            @click="() => $refs.tree.expandAll()"
          />
          <q-btn
            :disable="!customizeTree"
            flat
            round
            dense
            size="1.2em"
            icon="clear"
            @click="() => $refs.tree.collapseAll()"
          />
        </div>
        <q-scroll-area :visible="true" class="scroll">
          <div v-if="customizeTree">
            <q-tree
              ref="tree"
              :nodes="customizeTree"
              node-key="id"
              no-connectors
              @update:selected="selectNode"
            >
              <template v-slot:header-label="prop">
                <div class="row items-center">
                  <q-checkbox
                    :label="getLabel(prop)"
                    v-model="prop.node.selected"
                    color="primary"
                    @input="() => checkNode(prop)"
                  />
                  <div class="text-weight-bold text-primary">
                    <div
                      :class="
                        prop.node.children[0].action.length !=
                          prop.node.selectedChildren &&
                        prop.node.children[0].action.length !=
                          prop.node.selectedChildrenNot
                          ? 'circle-orange'
                          : prop.node.children[0].action.length ==
                            prop.node.selectedChildrenNot
                          ? 'circle-blue'
                          : 'circle-green'
                      "
                    ></div>

                  </div>
                </div>
              </template>
              <template v-slot:header-action="prop">
                <div class="row items-center">
                  <div v-for="(action, index) in prop.node.action" :key="index">
                    <div class="text-weight-bold text-primary">
                      <q-checkbox
                        v-model="action.selected"
                        color="primary"
                        @input="() => checkAction(prop)"
                      />
                      {{ action.label }}
                    </div>
                  </div>
                </div>
              </template>
            </q-tree>
          </div>
        </q-scroll-area>

        <div
          id="buttons-container"
          class="row full-width justify-center q-gutter-md"
        >
          <q-btn class="q-px-xl" color="info" @click="onClickChange"
            ><translate>CHANGE</translate></q-btn
          >
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { QTree, QCard, QCardSection, QScrollArea } from 'quasar'

import { JtCrud } from 'jtech-webcomps'
import { repository, messageBox } from 'jtech'
const { CrudLayout, form, input } = JtCrud

@Component({
  name: 'jt-profile-permission',
  mixins: [CrudLayout],
  components: {
    QTree,
    QCard,
    QCardSection,
    QScrollArea,
    'crud-form': form,
    'crud-input': input
  }
})
export default class JtProfilePermission extends Vue {
  forms = null;
  startList = [];
  startAcaoFuncionalidade = [];
  labelModulo = '';
  customizeTree = null;
  async created () {
    this.forms = await repository.resolve(this.interface, this.params)
  }

  onSelectChangeModulo ({ input, selectedValue }) {
    if (selectedValue && this.forms[0].dadosForm.segPerfilAcesso) {
      this.refresh({
        segModulo: selectedValue,
        segPerfilAcesso: this.forms[0].dadosForm.segPerfilAcesso
      })
    }
  }

  onSelectChangePerfilAcesso ({ input, selectedValue }) {
    if (selectedValue && this.forms[0].dadosForm.segModulo) {
      this.refresh({
        segPerfilAcesso: selectedValue,
        segModulo: this.forms[0].dadosForm.segModulo
      })
    }
  }

  async refresh ({ segPerfilAcesso, segModulo }) {
    const dados = await repository.resolveDatatableModel(this.interface, {
      segPerfilAcesso,
      segModulo
    })
    this.startList = []
    dados.registros.forEach((d) => this.startList.push(d.idAcaoFuncionalidade))
    const { registros } = await repository.resolveDatatableModel(
      'delegarPermissaoPerfilAcessoWaste.pesquisarDelegarPermissao',
      { segModulo }
    )
    this.startAcaoFuncionalidade = []
    const childrens = []
    registros.forEach((functionality) => {
      this.startAcaoFuncionalidade.push({
        idAcaoFuncionalidade: functionality.idAcaoFuncionalidade,
        chPontoAcesso: functionality.chPontoAcesso
      })
      let children = childrens.find(
        (children) => children.chPontoAcesso == functionality.chPontoAcesso
      )
      if (!children) {
        children = functionality
        functionality.id =
          functionality.chPontoAcesso + functionality.dsPontoAcesso
        functionality.label = functionality.dsPontoAcesso
        functionality.header = 'label'
        functionality.body = 'toggle'
        functionality.expanded = true
        functionality.children = [
          {
            label: functionality.idAcaoFuncionalidade,
            id: functionality.idAcaoFuncionalidade,
            idParent: functionality.chPontoAcesso + functionality.dsPontoAcesso,
            expanded: false,
            header: 'action',
            body: 'toggle',
            action: []
          }
        ]
        functionality.selected = false
        childrens.push(functionality)
      }
      children.children[0].action.push({
        label: functionality.nmAcao,
        selected: !!dados.registros.find(
          (x) => x.idAcaoFuncionalidade == functionality.idAcaoFuncionalidade
        ),
        idAcaoFuncionalidade: functionality.idAcaoFuncionalidade
      })
    })
    childrens.forEach((children) => this.analisyNodeSelected(children))
    this.customizeTree = childrens
    this.labelModulo = this.forms[0].relacionamentos.segModulo.find(
      (mod) => mod.value == this.forms[0].dadosForm.segModulo
    ).label
  }

  analisyNodeSelected (node) {
    node.selected = !node.children[0].action.find(
      (children) => children.selected == false
    )
    this.counterSelectionChildren(node)
  }

  checkNode ({ tree, node, key, color, dark, expanded, ticked }) {
    node.children[0].action.forEach(
      (action) => (action.selected = node.selected)
    )
    this.counterSelectionChildren(node)
  }

  counterSelectionChildren (node) {
    node.selectedChildren = 0
    node.selectedChildrenNot = 0
    node.children[0].action.forEach((children) =>
      children.selected ? ++node.selectedChildren : ++node.selectedChildrenNot
    )
  }

  getLabel (prop) {
    return `(${prop.node.children[0].action.length}) ${prop.node.label}`
  }

  checkAction ({ tree, node, key, color, dark, expanded, ticked }) {
    this.analisyNodeSelected(tree.getNodeByKey(node.idParent))
  }

  async onClickChange () {
    const idAcaoFuncionalidade = []
    this.customizeTree.forEach((node) => {
      node.children[0].action
        .filter((f) => f.selected)
        .forEach((action) => {
          idAcaoFuncionalidade.push(action.idAcaoFuncionalidade)
        })
    })
    // eslint-disable-next-line no-undef
    const drop = _.difference(this.startList, idAcaoFuncionalidade)
    // eslint-disable-next-line no-undef
    const add = _.difference(idAcaoFuncionalidade, this.startList)
    const { registros } = await repository.update(
      'delegarPermissaoPerfilAcessoWaste.alterarPerfilAcesso',
      {
        segPerfilAcesso: this.forms[0].dadosForm.segPerfilAcesso,
        segModulo: this.forms[0].dadosForm.segModulo,
        segPontoAcessoAcaoFuncionalidade: idAcaoFuncionalidade,
        drop: this.startAcaoFuncionalidade
          .filter((a) => drop.find((i) => i === a.idAcaoFuncionalidade))
          .map(
            (data) =>
              (data = data.chPontoAcesso + '-' + data.idAcaoFuncionalidade)
          )
          .toString(),
        add: this.startAcaoFuncionalidade
          .filter((a) => add.find((i) => i === a.idAcaoFuncionalidade))
          .map(
            (data) =>
              (data = data.chPontoAcesso + '-' + data.idAcaoFuncionalidade)
          )
          .toString()
      }
    )
  }
}
</script>
<style lang="css" scoped>
.scroll {
  height: 50vh;
  background-color: #EBEBEB;
  border-radius: 4px;
  padding: 1rem;
  margin-bottom: 1rem;
}
</style>
